/**
 * Kestrel Currency Converter Widget (display-only, client-side).
 *
 * Modal / wishlist prices arrive as base-currency WooCommerce HTML via REST.
 * Kestrel only rewrites existing `span.amount` nodes when told to — it does not
 * observe our modal. Trigger its documented calculate event after we inject prices.
 */
export function isKestrelCurrencyConverterActive() {
	return (
		typeof window !== 'undefined' &&
		typeof window.wc_currency_converter_params === 'object' &&
		window.wc_currency_converter_params !== null
	);
}

/**
 * Ask Kestrel to convert any newly injected price markup on the page.
 */
export function refreshConvertedPrices() {
	if (!isKestrelCurrencyConverterActive()) {
		return;
	}

	const run = () => {
		if (!window.jQuery) {
			return;
		}
		window.jQuery(document.body).trigger('wc_currency_converter_calculate');
	};

	// Wait until the browser has committed the new span.amount nodes.
	if (typeof window.requestAnimationFrame === 'function') {
		window.requestAnimationFrame(() => {
			window.requestAnimationFrame(run);
		});
		return;
	}

	window.setTimeout(run, 0);
}
